import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { RadioField } from '@/components/RadioField';

import type { BoutiqueMoreProps } from './BoutiquePickup';

import { ReactComponent as LocationIcon } from '@/assets/icons/locationWhite.svg';

export const BoutiqueList = styled(Flex)`
  flex-wrap: wrap;
  align-items: stretch;
`;
export const Content = styled(RadioField)`
  min-height: 96px;
  width: 100%;
  align-items: flex-start;
  margin: 0;
  ${({ theme }) => css`
    padding: ${theme.spacing(2)};
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.primaryAdd6};
  `}
`;

export const ContentMore = styled(Content)<BoutiqueMoreProps>`
  justify-content: center;
  align-items: center;
  ${({ isLoading }) => css`
    cursor: ${isLoading ? 'not-allowed' : 'pointer'};
    opacity: ${isLoading ? '0.4' : '1'};
  `}
` as any;

export const Wrapper = styled(Box)`
  flex: 0 0 100%;
  display: flex;
  ${({ theme }) => css`
    padding-top: ${theme.spacing(2)};
    ${theme.media.lg.up} {
      flex: 0 0 50%;
      &:nth-of-type(odd) {
        padding-right: ${theme.spacing(1)};
      }
      &:nth-of-type(even) {
        padding-left: ${theme.spacing(1)};
      }
    }
  `}
`;
export const BoutiqueFindInputWrapper = styled(Flex)`
  width: 100%;
  flex-direction: column;

  ${({ theme }) => css`
    background: ${theme.colors.mediumGrey};
    padding: ${theme.spacing(2)};
  `}
`;

export const Icon = styled(Box)`
  width: 24px;
`;

export const Location = styled(LocationIcon)`
  ${({ theme }) => css`
    background: ${theme.colors.transparent};
    & > path {
      fill: ${theme.colors.black};
    }
  `}
`;
